import React from 'react';
import { Button, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';

import { actionGlyph } from '../common/actionMenu';
import { normalizeId } from '../../utils/ids';

/**
 * The item's "Open" door: one icon button that lands on the item's own page
 * (/collections/:collectionId/items/:itemId). Opening is frequent enough
 * that it sits beside the ⋯ menu on every list surface (grid card, table
 * row) instead of inside it. Same glyph as the menu's "Open item" entry.
 *
 *   <ItemOpenButton item={item} collectionId={collectionId} />
 *
 * Clicks never bubble into the surrounding card/row's own select.
 */
export default function ItemOpenButton({ item, collectionId, size = 'small', className = '', buttonProps = {} }) {
	const navigate = useNavigate();
	const itemId = normalizeId(item?._id);
	const cid = normalizeId(collectionId) || normalizeId(item?.collection_id);
	if (!itemId || !cid) return null;
	const path = `/collections/${cid}/items/${itemId}`;
	const classes = ['item-open-button', className].filter(Boolean).join(' ');
	return (
		<Tooltip title="Open item">
			<Button
				type="text"
				size={size}
				icon={actionGlyph('open')}
				aria-label="Open item"
				className={classes}
				{...buttonProps}
				onClick={event => {
					event.stopPropagation();
					navigate(path);
				}}
			/>
		</Tooltip>
	);
}
